(() => {
  // app/scripts/common/section/slideshow.js
  var SlideShow = {
    onLoad: function() {
      let container = this.container;
      try {
        this.elms = {
          slideshowContainer: container.querySelector(".js-tns-container")
        };
        this.initTns();
      } catch (error) {
        console.warn("Section SlideShow has an error:", error);
        console.log(container);
      }
    },
    initTns: function() {
      let { slideshowContainer } = this.elms;
      let config = JSON.parse(slideshowContainer.querySelector("[data-tns-config]").innerHTML);
      try {
        this.tns = tns(config);
      } catch (error) {
        console.warn("Tiny Slider initialization failed.", error);
        console.log(this.container);
      }
    }
  };

  // app/scripts/common/arn.js
  var AT2 = {
    currency: /* @__PURE__ */ function() {
      var moneyFormatString = "${{amount}}";
      function moneyFormat(cents, format) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormatString;
        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ",";
          decimal = decimal || ".";
          if (isNaN(number) || number === null) {
            return 0;
          }
          number = (number / 100).toFixed(precision);
          var parts = number.split(".");
          var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
          var centsAmount = parts[1] ? decimal + parts[1] : "";
          return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }
        return formatString.replace(placeholderRegex, value);
      }
      return {
        moneyFormat
      };
    }(),
    debounce: (func, wait) => {
      let timeout;
      return (...args) => {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    initTNS: function(container) {
      let tnsContainer = container.getElementsByClassName("js-tns")[0];
      let controlsContainer = container.getElementsByClassName("js-tns-controls")[0];
      let configId = tnsContainer.getAttribute("data-config");
      let config = !!configId && JSON.parse(document.getElementById(configId).innerHTML) || {};
      if (!!config.controls) {
        config.controlsContainer = controlsContainer;
      }
      if (config.itemClass !== "" && typeof config.itemClass !== "undefined") {
        for (const item of tnsContainer.children) {
          item.className = config.itemClass;
        }
      }
      Object.assign(config, {
        container: tnsContainer,
        onInit: function() {
          tnsContainer.classList.remove("row", "d-grid");
        }
      });
      return tns(config);
    },
    initBackToTop: function() {
      let btnToTop = document.getElementById("back-to-top");
      !!btnToTop && btnToTop.addEventListener("click", function(e) {
        AT2.scrollTo(0);
      });
      window.addEventListener("scroll", function() {
        if (window.pageYOffset > window.innerHeight) {
          btnToTop.classList.add("show");
        } else {
          btnToTop.classList.remove("show");
        }
      });
    },
    initAddToCart: function(form) {
      let btnAddToCart = form.getElementsByClassName("btn-add-to-cart")[0];
      form.addEventListener("submit", function(e) {
        e.preventDefault();
        btnAddToCart.classList.add("pending");
        fetch("/cart/add.js", {
          method: "post",
          headers: new Headers(),
          body: new FormData(form)
        }).then((res) => res.json()).then((dataProduct) => {
          fetch("/cart.js").then((res) => res.json()).then((cart) => {
            AT2.cart = cart;
            AT2.dispatchEvent("cartChange", cart);
            btnAddToCart.classList.remove("pending");
            console.log("my add-to-cart");
            AT2.dispatchEvent("cartNotify", dataProduct);
          });
        }).catch((err) => console.log(err.message));
      });
    },
    initQty: function(qtyContainer) {
      let qtyInput = qtyContainer.querySelector("input[name='quantity']");
      qtyContainer.querySelector(".js-quantity-plus").addEvent("click", function() {
        qtyInput.value = +qtyInput.value + 1;
      });
      qtyContainer.querySelector(".js-quantity-minus").addEvent("click", function() {
        qtyInput.value > 1 && (qtyInput.value = +qtyInput.value - 1);
      });
    },
    offModal: function() {
      document.querySelectorAll(".modal.is-open").removeClass("is-open");
    },
    getCart: function() {
      fetch("/cart.js").then((res) => res.json()).then((cart) => AT2.cart = cart);
    },
    loadCartNotify: function() {
      let script = document.createElement("script");
      script.src = theme.url.cartNotify;
      document.head.append(script);
    },
    loadQuickView: function() {
      let script = document.createElement("script");
      script.src = theme.url.quickView;
      document.head.append(script);
      document.getElementById("lazy_quick_view").addClass("lazyload");
    },
    loadFilter: function(cb) {
      let script = document.createElement("script");
      script.src = theme.url.filter;
      script.onload = cb;
      document.body.append(script);
    },
    scrollToTop: function() {
      let bodyTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (bodyTop > 0) {
        window.requestAnimationFrame(AT2.scrollToTop);
        window.scrollTo(0, bodyTop - 100);
      }
    },
    scrollTo: (position) => {
      let pageYoffset = window.pageYOffset;
      let boolean = position - pageYoffset > 0 ? true : false;
      let distance = Math.abs((pageYoffset - position) / 10);
      requestAnimationFrame(step);
      function step() {
        if (boolean) {
          if (pageYoffset < position) {
            window.scrollTo(0, (pageYoffset += distance) > position ? position : pageYoffset);
            requestAnimationFrame(step);
          }
        } else {
          if (pageYoffset > position) {
            window.scrollTo(
              0,
              pageYoffset >= distance ? pageYoffset -= distance : (pageYoffset = position - 1, position)
            );
            requestAnimationFrame(step);
          }
        }
      }
    },
    setCookie: function(key, value, expiry) {
      var expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
    },
    getCookie: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? keyValue[2] : null;
    },
    deleteCookie: function(key) {
      var keyValue = this.getCookie(key);
      this.setCookie(key, keyValue, "-1");
    },
    handle: (text) => {
      return text.toLowerCase().replace(/[^\w\s.\//]/gi, "").trim().replace(/[\s.\//]/g, "-");
    },
    disableScroll: function() {
      document.documentElement.style.paddingRight = window.innerWidth - document.documentElement.clientWidth + "px";
      document.documentElement.style.overflow = "hidden";
    },
    enableScroll: function() {
      document.documentElement.style.overflow = "";
      document.documentElement.style.paddingRight = "";
    }
  };
  var arn_default = AT2;

  // node_modules/mustache/mustache.mjs
  /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */
  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill(object) {
    return objectToString.call(object) === "[object Array]";
  };
  function isFunction(object) {
    return typeof object === "function";
  }
  function typeStr(obj) {
    return isArray(obj) ? "array" : typeof obj;
  }
  function escapeRegExp(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }
  function hasProperty(obj, propName) {
    return obj != null && typeof obj === "object" && propName in obj;
  }
  function primitiveHasOwnProperty(primitive, propName) {
    return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
  }
  var regExpTest = RegExp.prototype.test;
  function testRegExp(re, string) {
    return regExpTest.call(re, string);
  }
  var nonSpaceRe = /\S/;
  function isWhitespace(string) {
    return !testRegExp(nonSpaceRe, string);
  }
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
    "`": "&#x60;",
    "=": "&#x3D;"
  };
  function escapeHtml(string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
      return entityMap[s];
    });
  }
  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;
  function parseTemplate(template, tags) {
    if (!template)
      return [];
    var lineHasNonSpace = false;
    var sections = [];
    var tokens = [];
    var spaces = [];
    var hasTag = false;
    var nonSpace = false;
    var indentation = "";
    var tagIndex = 0;
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }
      hasTag = false;
      nonSpace = false;
    }
    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags(tagsToCompile) {
      if (typeof tagsToCompile === "string")
        tagsToCompile = tagsToCompile.split(spaceRe, 2);
      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error("Invalid tags: " + tagsToCompile);
      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
      closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
    }
    compileTags(tags || mustache.tags);
    var scanner = new Scanner(template);
    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;
      value = scanner.scanUntil(openingTagRe);
      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);
          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
            indentation += chr;
          } else {
            nonSpace = true;
            lineHasNonSpace = true;
            indentation += " ";
          }
          tokens.push(["text", chr, start, start + 1]);
          start += 1;
          if (chr === "\n") {
            stripSpace();
            indentation = "";
            tagIndex = 0;
            lineHasNonSpace = false;
          }
        }
      }
      if (!scanner.scan(openingTagRe))
        break;
      hasTag = true;
      type = scanner.scan(tagRe) || "name";
      scanner.scan(whiteRe);
      if (type === "=") {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === "{") {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = "&";
      } else {
        value = scanner.scanUntil(closingTagRe);
      }
      if (!scanner.scan(closingTagRe))
        throw new Error("Unclosed tag at " + scanner.pos);
      if (type == ">") {
        token = [type, value, start, scanner.pos, indentation, tagIndex, lineHasNonSpace];
      } else {
        token = [type, value, start, scanner.pos];
      }
      tagIndex++;
      tokens.push(token);
      if (type === "#" || type === "^") {
        sections.push(token);
      } else if (type === "/") {
        openSection = sections.pop();
        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);
        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === "name" || type === "{" || type === "&") {
        nonSpace = true;
      } else if (type === "=") {
        compileTags(value);
      }
    }
    stripSpace();
    openSection = sections.pop();
    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
    return nestTokens(squashTokens(tokens));
  }
  function squashTokens(tokens) {
    var squashedTokens = [];
    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];
      if (token) {
        if (token[0] === "text" && lastToken && lastToken[0] === "text") {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }
    return squashedTokens;
  }
  function nestTokens(tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];
    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];
      switch (token[0]) {
        case "#":
        case "^":
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case "/":
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }
    return nestedTokens;
  }
  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }
  Scanner.prototype.eos = function eos() {
    return this.tail === "";
  };
  Scanner.prototype.scan = function scan(re) {
    var match = this.tail.match(re);
    if (!match || match.index !== 0)
      return "";
    var string = match[0];
    this.tail = this.tail.substring(string.length);
    this.pos += string.length;
    return string;
  };
  Scanner.prototype.scanUntil = function scanUntil(re) {
    var index = this.tail.search(re), match;
    switch (index) {
      case -1:
        match = this.tail;
        this.tail = "";
        break;
      case 0:
        match = "";
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }
    this.pos += match.length;
    return match;
  };
  function Context(view, parentContext) {
    this.view = view;
    this.cache = { ".": this.view };
    this.parent = parentContext;
  }
  Context.prototype.push = function push(view) {
    return new Context(view, this);
  };
  Context.prototype.lookup = function lookup(name) {
    var cache = this.cache;
    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this, intermediateValue, names, index, lookupHit = false;
      while (context) {
        if (name.indexOf(".") > 0) {
          intermediateValue = context.view;
          names = name.split(".");
          index = 0;
          while (intermediateValue != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
            intermediateValue = intermediateValue[names[index++]];
          }
        } else {
          intermediateValue = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }
        if (lookupHit) {
          value = intermediateValue;
          break;
        }
        context = context.parent;
      }
      cache[name] = value;
    }
    if (isFunction(value))
      value = value.call(this.view);
    return value;
  };
  function Writer() {
    this.templateCache = {
      _cache: {},
      set: function set(key, value) {
        this._cache[key] = value;
      },
      get: function get(key) {
        return this._cache[key];
      },
      clear: function clear() {
        this._cache = {};
      }
    };
  }
  Writer.prototype.clearCache = function clearCache() {
    if (typeof this.templateCache !== "undefined") {
      this.templateCache.clear();
    }
  };
  Writer.prototype.parse = function parse(template, tags) {
    var cache = this.templateCache;
    var cacheKey = template + ":" + (tags || mustache.tags).join(":");
    var isCacheEnabled = typeof cache !== "undefined";
    var tokens = isCacheEnabled ? cache.get(cacheKey) : void 0;
    if (tokens == void 0) {
      tokens = parseTemplate(template, tags);
      isCacheEnabled && cache.set(cacheKey, tokens);
    }
    return tokens;
  };
  Writer.prototype.render = function render(template, view, partials, config) {
    var tags = this.getConfigTags(config);
    var tokens = this.parse(template, tags);
    var context = view instanceof Context ? view : new Context(view, void 0);
    return this.renderTokens(tokens, context, partials, template, config);
  };
  Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
    var buffer = "";
    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = void 0;
      token = tokens[i];
      symbol = token[0];
      if (symbol === "#")
        value = this.renderSection(token, context, partials, originalTemplate, config);
      else if (symbol === "^")
        value = this.renderInverted(token, context, partials, originalTemplate, config);
      else if (symbol === ">")
        value = this.renderPartial(token, context, partials, config);
      else if (symbol === "&")
        value = this.unescapedValue(token, context);
      else if (symbol === "name")
        value = this.escapedValue(token, context, config);
      else if (symbol === "text")
        value = this.rawValue(token);
      if (value !== void 0)
        buffer += value;
    }
    return buffer;
  };
  Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
    var self = this;
    var buffer = "";
    var value = context.lookup(token[1]);
    function subRender(template) {
      return self.render(template, context, partials, config);
    }
    if (!value)
      return;
    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
      }
    } else if (typeof value === "object" || typeof value === "string" || typeof value === "number") {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== "string")
        throw new Error("Cannot use higher-order sections without the original template");
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
    }
    return buffer;
  };
  Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
    var value = context.lookup(token[1]);
    if (!value || isArray(value) && value.length === 0)
      return this.renderTokens(token[4], context, partials, originalTemplate, config);
  };
  Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
    var filteredIndentation = indentation.replace(/[^ \t]/g, "");
    var partialByNl = partial.split("\n");
    for (var i = 0; i < partialByNl.length; i++) {
      if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) {
        partialByNl[i] = filteredIndentation + partialByNl[i];
      }
    }
    return partialByNl.join("\n");
  };
  Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
    if (!partials)
      return;
    var tags = this.getConfigTags(config);
    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null) {
      var lineHasNonSpace = token[6];
      var tagIndex = token[5];
      var indentation = token[4];
      var indentedValue = value;
      if (tagIndex == 0 && indentation) {
        indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
      }
      var tokens = this.parse(indentedValue, tags);
      return this.renderTokens(tokens, context, partials, indentedValue, config);
    }
  };
  Writer.prototype.unescapedValue = function unescapedValue(token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };
  Writer.prototype.escapedValue = function escapedValue(token, context, config) {
    var escape = this.getConfigEscape(config) || mustache.escape;
    var value = context.lookup(token[1]);
    if (value != null)
      return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
  };
  Writer.prototype.rawValue = function rawValue(token) {
    return token[1];
  };
  Writer.prototype.getConfigTags = function getConfigTags(config) {
    if (isArray(config)) {
      return config;
    } else if (config && typeof config === "object") {
      return config.tags;
    } else {
      return void 0;
    }
  };
  Writer.prototype.getConfigEscape = function getConfigEscape(config) {
    if (config && typeof config === "object" && !isArray(config)) {
      return config.escape;
    } else {
      return void 0;
    }
  };
  var mustache = {
    name: "mustache.js",
    version: "4.2.0",
    tags: ["{{", "}}"],
    clearCache: void 0,
    escape: void 0,
    parse: void 0,
    render: void 0,
    Scanner: void 0,
    Context: void 0,
    Writer: void 0,
    /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */
    set templateCache(cache) {
      defaultWriter.templateCache = cache;
    },
    /**
     * Gets the default or overridden caching object from the default writer.
     */
    get templateCache() {
      return defaultWriter.templateCache;
    }
  };
  var defaultWriter = new Writer();
  mustache.clearCache = function clearCache2() {
    return defaultWriter.clearCache();
  };
  mustache.parse = function parse2(template, tags) {
    return defaultWriter.parse(template, tags);
  };
  mustache.render = function render2(template, view, partials, config) {
    if (typeof template !== "string") {
      throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first argument for mustache#render(template, view, partials)');
    }
    return defaultWriter.render(template, view, partials, config);
  };
  mustache.escape = escapeHtml;
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

  // app/scripts/common/snippet/product/product-zoom.js
  function initPhotoSwipeFromDOM(galleryElement) {
    var parseThumbnailElements = (el) => {
      let items = [], item;
      el.querySelectorAll(".media-item").forEach((element) => {
        let img = element.querySelector("img");
        item = {
          src: element.dataset.imgUrl,
          w: +img.getAttribute("width"),
          h: +img.getAttribute("height"),
          el: img
        };
        item.o = {
          src: item.src,
          w: +img.getAttribute("width"),
          h: +img.getAttribute("height")
        };
        items.push(item);
      });
      return items;
    };
    var closest = (el, fn) => {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };
    var onThumbnailsClick = (e) => {
      e.preventDefault();
      var eTarget = e.target || e.srcElement;
      var clickedListItem = closest(eTarget, (el) => {
        return el.hasClass("media-item");
      });
      if (!clickedListItem) {
        return;
      }
      openPhotoSwipe(clickedListItem.dataset.position - 1);
      return false;
    };
    var openPhotoSwipe = (index, disableAnimation, fromURL) => {
      var pswpElement = document.getElementById("modal-image-zoom"), gallery, options, items;
      items = parseThumbnailElements(galleryElement);
      options = {
        galleryUID: galleryElement.getAttribute("data-pswp-uid"),
        getThumbBoundsFn: function(index2) {
          var thumbnail = items[index2].el, pageYScroll = window.pageYOffset || document.documentElement.scrollTop, rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
        // addCaptionHTMLFn: function (item, captionEl, isFake) {
        //   if (!item.title) {
        //     captionEl.children[0].innerText = "";
        //     return false;
        //   }
        //   captionEl.children[0].innerHTML = item.title + "<br/><small>Photo: " + item.author + "</small>";
        //   return true;
        // },
      };
      if (fromURL) {
        if (options.galleryPIDs) {
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }
      if (isNaN(options.index)) {
        return;
      }
      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      var realViewportWidth, useLargeImages = false, firstResize = true, imageSrcWillChange;
      gallery.listen("beforeResize", function() {
        var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        dpiRatio = Math.min(dpiRatio, 2.5);
        realViewportWidth = gallery.viewportSize.x * dpiRatio;
        if (realViewportWidth >= 1200 || !gallery.likelyTouchDevice && realViewportWidth > 800 || screen.width > 1200) {
          if (!useLargeImages) {
            useLargeImages = true;
            imageSrcWillChange = true;
          }
        } else {
          if (useLargeImages) {
            useLargeImages = false;
            imageSrcWillChange = true;
          }
        }
        if (imageSrcWillChange && !firstResize) {
          gallery.invalidateCurrItems();
        }
        if (firstResize) {
          firstResize = false;
        }
        imageSrcWillChange = false;
      });
      gallery.listen("afterChange", () => {
        if (!!this.mainSlider && typeof this.mainSlider.goTo === "function") {
          this.mainSlider.goTo(gallery.getCurrentIndex());
        }
      });
      gallery.listen("gettingData", function(index2, item) {
        item.src = item.o.src;
        item.w = item.o.w;
        item.h = item.o.h;
      });
      gallery.init();
    };
    galleryElement.querySelectorAll("img").forEach((item) => {
      let isMoving = false;
      let startEvent = false;
      item.addEvent("mousedown", () => {
        startEvent = true;
      });
      item.addEvent("mouseup", (e) => {
        if (!isMoving) {
          onThumbnailsClick(e);
        }
        startEvent = false;
        isMoving = false;
      });
      item.addEvent("mousemove", (e) => {
        if (startEvent) {
          isMoving = true;
        }
      });
    });
    galleryElement.setAttribute("data-pswp-uid", 1);
  }

  // app/scripts/functions/ymmUtils.js
  var ymmOptions = {
    appName: "ymm",
    shopName: "modula-racks"
  };
  var API = `/apps/${ymmOptions.appName}/api/elastic/products-${ymmOptions.shopName}/_search`;
  var FITMENT_TABLE_API = `/apps/${ymmOptions.appName}/api/elastic/products-${ymmOptions.shopName}/_doc`;
  function getFitmentTableData(productID) {
    return new Promise((resolve, reject) => {
      fetch(FITMENT_TABLE_API + "/" + productID).then((res) => res.json()).then((res) => resolve(res)).catch((error) => reject(error));
    });
  }

  // app/scripts/common/section/product-default.js
  var ProductDefault = {
    optionsMap: {},
    onLoad: function() {
      let _this = this;
      let { container } = _this;
      this.product = theme.product;
      this.hasFitment = false;
      this.field1_title = theme.fields.field1;
      this.field2_title = theme.fields.field2;
      this.field3_title = theme.fields.field3;
      this.field4_title = theme.fields.field4;
      this.elms = {
        mediaMain: container.querySelector("#product_main_media"),
        mediaThumbnail: container.querySelector("#product_thumbnails_media"),
        formElm: container.querySelector("form[action='/cart/add']"),
        tabsElm: container.querySelector("#product-tabs"),
        options: container.querySelector(".js-form-options"),
        priceElm: container.querySelector(".js-price"),
        skuContainer: container.querySelector(".js-sku-parent"),
        priceCompareElm: container.querySelector(".js-price-compare"),
        modalAvailability: document.getElementById("js-modal-availability"),
        selectMaster: container.querySelector(".js-select-master"),
        btnSubmit: container.querySelector(
          "form[action*='/cart/add'] button[type='submit']"
        ),
        btnInstructions: container.querySelector(".js-btn-instructions"),
        modalInstructions: container.querySelector("#modal_instructions"),
        inventoryContainer: container.querySelector(".js-product-inventory"),
        availability: container.querySelector(".js-availability"),
        inventoryQuantityContainer: container.querySelector(
          ".js-inventory-quantity-container"
        )
      };
      this.variantsInventory = JSON.parse(container.querySelector("script[data-variants-inventory]").innerHTML);
      if (!!theme.product.media && theme.product.media.length > 1) {
        this.initMedia();
      }
      document.addEventListener("variantChange", this.handleVariantChange.bind(this));
      !new URLSearchParams(location.search).get("variant") && this.product.available && this.product.variants.length > 1 && this.linkOptionSelectors(this.product);
      this.initEvents();
      if (!!this.elms.btnInstructions) {
        this.initBtnInstructions();
      }
      this.initHandleTabs();
      if (!!document.getElementById("product_tab_fitment")) {
        document.addEventListener(
          "filter-init",
          () => {
            this.renderFitmentList().then(() => {
              this.toggle();
              this.initHandleProductFit();
              this.initTabFitment();
            });
          },
          { once: true }
        );
      }
      this.elms.availability?.addEvent("click", function() {
        _this.showModalAvailability();
      });
      _this.eventKitHref();
      initPhotoSwipeFromDOM(this.elms.mediaMain);
    },
    initMedia: function() {
      let { mediaMain, mediaThumbnail } = this.elms;
      (function() {
        let config = JSON.parse(mediaMain.querySelector("[data-tns-config]").innerHTML);
        config.gutter = 5;
        config.autoHeight = true;
        config.onInit = (e) => {
          let { index } = e;
          e.slideItems[index].addClass("visibility");
        };
        let slider = this.slider = tns(config);
        slider.events.on("indexChanged", customizedFunction);
        function customizedFunction(e) {
          let index = e.index;
          let slideItem = e.slideItems[index];
          if (!slideItem.hasClass("visibility")) {
            slideItem.addClass("visibility");
            [...e.slideItems].every((item) => item.hasClass("visibility")) && slider.events.off("indexChanged", customizedFunction);
          }
        }
      }).call(this);
      (function() {
        let config = JSON.parse(mediaThumbnail.querySelector("[data-tns-config]").innerHTML);
        config.onInit = (e) => {
          let itemsActive = [...e.slideItems].filter((item) => item.hasClass("tns-slide-active"));
          itemsActive.forEach((item) => item.addClass("visibility"));
        };
        let slide = tns(config);
        slide.events.on("indexChanged", customizedFunction);
        function customizedFunction(e) {
          let itemsActive = [...e.slideItems].filter((item) => item.hasClass("tns-slide-active"));
          itemsActive.forEach((item) => !item.hasClass("visibility") && item.addClass("visibility"));
        }
      }).call(this);
    },
    initEvents: function() {
      let { formElm, options, btnSubmit, selectMaster } = this.elms;
      let qtyContainer = formElm.querySelector(".js-qty-container");
      arn_default.initQty(qtyContainer);
      if (this.product.variants.length > 1) {
        options.querySelectorAll("input").addEvent("change", (e) => {
          switch (e.target.name) {
            case "option1":
              if (this.product.options.length > 1) {
                this.updateOptionsInSelector(2);
              }
              if (this.product.options.length === 3) {
                this.updateOptionsInSelector(3);
              }
              break;
            case "option2":
              if (this.product.options.length === 3) {
                this.updateOptionsInSelector(3);
              }
              break;
          }
          document.dispatchEvent(new CustomEvent("variantChange"));
        });
        options.querySelectorAll("select.js-option-item").addEvent("change", (e) => {
          switch (e.target.name) {
            case "option1":
              if (this.product.options.length > 1) {
                this.updateOptionsInSelector(2);
              }
              if (this.product.options.length === 3) {
                this.updateOptionsInSelector(3);
              }
              break;
            case "option2":
              if (this.product.options.length === 3) {
                this.updateOptionsInSelector(3);
              }
              break;
          }
          document.dispatchEvent(new CustomEvent("variantChange"));
        });
      }
      window.addEventListener("load", (event) => {
        btnSubmit.style.pointerEvents = "auto";
      });
      formElm.addEvent("submit", function(e) {
        e.preventDefault();
        let relatedProducts = [];
        if (e.target.querySelector("input[name='related-products']")) {
          relatedProducts = e.target.querySelector("input[name='related-products']").value.split(",");
        }
        let id = parseInt(selectMaster.value), subcomponents = selectMaster.options[selectMaster.selectedIndex].dataset.subcomponents, quantity = parseInt(this.quantity.value);
        let formData = {
          "items": []
        };
        if (subcomponents === "true") {
          let tabsId = document.querySelectorAll("[data-tabs-variant-id]");
          tabsId?.forEach((tabID) => {
            let idVariant = parseInt(tabID.dataset.tabsVariantId);
            if (idVariant === id) {
              let components = tabID.querySelectorAll("[data-bom-component-id]");
              components.forEach((component) => {
                let componentID = parseInt(component.dataset.bomComponentId), componentQuantity = parseInt(component.dataset.bomComponentQuantity);
                formData.items.push({
                  id: componentID,
                  quantity: componentQuantity
                });
                return;
              });
            }
          });
        } else {
          formData = {
            items: [
              {
                id,
                quantity
              }
            ]
          };
        }
        btnSubmit.addClass("pending");
        fetch("/cart/add.js", {
          method: "POST",
          body: JSON.stringify(formData),
          headers: { "Content-Type": "application/json" },
          relatedProducts,
          productID: this.getAttribute("data-product-id")
        }).finally(() => {
          btnSubmit.removeClass("pending");
        });
      });
    },
    initHandleTabs: function() {
      let { tabsElm } = this.elms;
      let { container } = this;
      let tabNav = tabsElm.querySelector(".js-tab-nav");
      let tabContent = tabsElm.querySelector(".js-tab-content");
      let tabQA, tabReview, tabQuestion;
      tabNav.children.addEvent("click", function() {
        tabNav.children.removeClass("active");
        let position = this.getAttribute("data-position");
        let tabContentItem;
        for (const child of tabContent.children) {
          child.removeClass("active");
          if (child.getAttribute("data-position") === position) {
            tabContentItem = child;
          }
        }
        tabContentItem.addClass("active");
        this.addClass("active");
        if (window.innerWidth < 991) {
          tabNav.scrollLeft = this.offsetLeft - tabNav.offsetWidth / 4;
        }
      });
      if (tabReview = tabNav.querySelector("#product_tab_review")) {
        container.querySelector(".js-btn-add-review").addEvent("click", () => {
          tabReview.click();
        });
      }
      if (tabQuestion = tabNav.querySelector("#product_tab_review")) {
        [...container.querySelectorAll(".js-question")].forEach((e) => {
          e.addEvent("click", () => {
            tabQuestion.click();
          });
        });
      }
    },
    handleVariantChange: function() {
      let { options, btnSubmit, inventoryContainer } = this.elms;
      let { product } = this;
      let btnNoti = document.querySelector(".js-noti-out-stock");
      let optionValues = [...new FormData(options).entries()].reduce((accu, currentValue) => {
        accu[currentValue[0]] = currentValue[1];
        return accu;
      }, {});
      let variantFound = product.variants.find(
        (variant) => Object.keys(optionValues).every((key) => optionValues[key] === variant[key])
      );
      product.variants.forEach((variant) => {
        if (!variant.available) {
          document.querySelector(`[data-color='${variant.title}']`)?.addClass("disabled");
        }
      });
      if (!!variantFound && !variantFound.available) {
        document.querySelector(`[data-color='${variantFound.title}']`)?.removeClass("disabled");
      }
      if (!variantFound) {
        btnSubmit.disabled = true;
        btnNoti.parentNode.classList.add("inventory-continue");
        inventoryContainer.setAttribute("data-status", "unavailable");
        return;
      }
      this.updateProduct(variantFound);
      this.updateTabsContent(variantFound);
      this.updateKlarna(variantFound);
      this.updateVariantURL(variantFound);
    },
    updateProduct: function(variant) {
      let {
        priceElm,
        priceCompareElm,
        selectMaster,
        skuContainer,
        btnSubmit,
        inventoryContainer
      } = this.elms;
      let variant_info = this.variantsInventory[variant.id];
      let regular_oversellable = inventoryContainer.dataset.regularOversellable;
      priceElm.innerHTML = variant.price.toCurrency();
      !!priceCompareElm && (priceCompareElm.innerHTML = !!variant.compare_at_price ? variant.compare_at_price.toCurrency() : "");
      !!variant.featured_media && !!this.slider && this.slider.goTo(variant.featured_media.position - 1);
      if (regular_oversellable == "true") {
        if (variant_info.quantity > 0 || variant_info.policy == "continue") {
          btnSubmit.disabled = false;
        } else {
          btnSubmit.disabled = true;
        }
      } else {
        if (variant_info.quantity <= 0 && variant_info.policy == "continue" && variant_info.BomJson && (!variant_info.isSubcomponents || !variant_info.isVendor) || !variant.available) {
          btnSubmit.disabled = true;
        } else {
          btnSubmit.disabled = false;
        }
      }
      !!document.querySelector(".klaviyo-api #variant") && (document.querySelector(".klaviyo-api #variant").value = variant.id);
      selectMaster.value = variant.id;
      this.updateInventory(variant);
      if (document.querySelector(".affirm-modal-trigger")) {
        document.querySelector(".affirm-modal-trigger").dataset.amount = variant.price;
        affirm.ui.refresh();
      }
    },
    updateVariantURL: function(variant) {
      if (!variant)
        return;
      let newUrl = [];
      if (location.search) {
        const url = new URL(location.href);
        const params = url.searchParams;
        for (const [key, value] of params.entries()) {
          newUrl.push({ name: key, value });
        }
        newUrl = newUrl.filter((i) => i.name != "variant").map(({ name, value }) => `${name}=${value}`);
      }
      newUrl.push(`variant=${variant.id}`);
      history.replaceState(null, null, `${location.pathname}?${newUrl.join("&")}`);
    },
    updateTabsContent: function(variant) {
      let contents = document.querySelectorAll("[data-tabs-variant-id]");
      contents.forEach((content) => {
        let id = parseInt(content.dataset.tabsVariantId);
        if (id == variant.id) {
          let isAvailable = content.dataset.available;
          content.classList.remove("d-none");
          if (!isAvailable || isAvailable == "false") {
            //!isAvailable | isAvailable == 'false'
            document.querySelector("#product_tab_QA")?.classList.add("d-none");
            content.closest(".content-item")?.classList.add("d-none");
          } else {
            document.querySelector("#product_tab_QA")?.classList.remove("d-none");
            content.closest(".content-item")?.classList.remove("d-none");
          }
        } else {
          content.classList.add("d-none");
        }
      });
    },
    updateKlarna: function(variant) {
      window?.KOSMApp?.updatePurchaseAmount?.(variant.price);
    },
    eventKitHref: function() {
      return;
      let product_tab_QA = document.querySelector("#product_tab_QA");
      if (!product_tab_QA) {
        return;
      }
      let productSkuList = document.querySelectorAll("[data-bom-component-id]");
      if (productSkuList.length > 0) {
        let arrPromise = [...productSkuList].map((elm) => {
          let dataSku = elm.dataset.sku;
          let url = `/search?q=${dataSku}&section_id=product-href`;
          return fetch(url).then((response) => response.text());
        });
        Promise.all(arrPromise).then((res) => {
          res.forEach((data, index) => {
            let dataNew = new DOMParser().parseFromString(data, "text/html").querySelector("a");
            let dataHref = dataNew.dataset.href;
            productSkuList[index].querySelector(".item a").setAttribute("href", dataHref);
            productSkuList[index].querySelector(".item a").innerHTML = dataNew.innerHTML;
          });
        });
      }
    },
    linkOptionSelectors: function(product) {
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant) {
          this.optionsMap["root"] = this.optionsMap["root"] || [];
          this.optionsMap["root"].push(variant.option1);
          this.optionsMap["root"] = this.optionsMap["root"].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
          if (product.options.length > 1) {
            var key = variant.option1;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option2);
            this.optionsMap[key] = this.optionsMap[key].reduce((accu, currentvalue) => {
              if (!accu.includes(currentvalue)) {
                accu.push(currentvalue);
              }
              return accu;
            }, []);
          }
          if (product.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option3);
            this.optionsMap[key] = this.optionsMap[key].reduce((accu, currentvalue) => {
              if (!accu.includes(currentvalue)) {
                accu.push(currentvalue);
              }
              return accu;
            }, []);
          }
        }
      }
      this.updateOptionsInSelector(1);
      if (product.options.length > 1)
        this.updateOptionsInSelector(2);
      if (product.options.length === 3)
        this.updateOptionsInSelector(3);
    },
    updateOptionsInSelector: function(index) {
      let { options } = this.elms;
      let checked = true;
      let optionValues = this.getOptionValues();
      let key, selector;
      switch (index) {
        case 1:
          key = "root";
          selector = options.querySelector(".option-item[data-position='1']");
          break;
        case 2:
          key = optionValues.option1;
          selector = options.querySelector(".option-item[data-position='2']");
          break;
        case 3:
          key = optionValues.option1 + " / " + optionValues.option2;
          selector = options.querySelector(".option-item[data-position='3']");
          break;
      }
      selector.querySelectorAll("input")?.forEach((input) => {
        if (typeof this.optionsMap[key] !== "undefined") {
          if (this.optionsMap[key].includes(input.value)) {
            input.disabled = false;
            input.closest(".input-group").removeClass("disabled");
            checked && (input.checked = true, checked = false);
          } else {
            input.checked = false;
            input.closest(".input-group").addClass("disabled");
          }
        }
      });
      document.dispatchEvent(new CustomEvent("variantChange"));
    },
    getOptionValues: function() {
      let { options } = this.elms;
      return [...new FormData(options).entries()].reduce((accu, currentValue) => {
        accu[currentValue[0]] = currentValue[1];
        return accu;
      }, {});
    },
    integrateWishlist: function() {
      let btnShowWishList = document.querySelector(".show-wishlist[data-arn-action='show']");
      document.addEventListener("add-done", function() {
        btnShowWishList.click();
      });
    },
    initTabFitment: function() {
      let lastSearch = arn_default.getCookie("arn-filter");
      let fitmentAlert = document.getElementById("fitment-alert-tab");
      let fitmentVehicleSpecific = fitmentAlert.querySelector(".js-fitment-vehicle-specific");
      let fitmentNoMatch = fitmentAlert.querySelector(".js-fitment-nomatch");
      let btnSelectVehicle = fitmentAlert.querySelector(".js-select-vehicle");
      let btnChange = fitmentAlert.querySelector(".js-change-vehicle");
      if (!lastSearch) {
        fitmentVehicleSpecific.removeClass("d-none");
      } else if (!this.hasFitment) {
        fitmentNoMatch.removeClass("d-none");
      }
      btnSelectVehicle.addEvent("click", () => {
        document.dispatchEvent(new CustomEvent("open-filter-modal"));
      });
      btnChange.addEvent("click", () => {
        document.dispatchEvent(new CustomEvent("open-filter-modal"));
      });
      fitmentAlert.removeClass("d-none");
      document.addEventListener("changeVehicle", async ({ detail }) => {
        this.hasFitment = await this.isFitment();
        if (!!detail) {
          fitmentVehicleSpecific.addClass("d-none");
          if (this.hasFitment) {
            fitmentNoMatch.addClass("d-none");
          } else {
            fitmentNoMatch.removeClass("d-none");
          }
        } else {
          fitmentVehicleSpecific.removeClass("d-none");
          fitmentNoMatch.addClass("d-none");
        }
      });
    },
    initHandleProductFit: function() {
      let lastSearch = arn_default.getCookie("arn-filter");
      let productFitElm = this.container.querySelector(".js-product-fit");
      if (!productFitElm)
        return;
      let productFitmentNomatch = productFitElm.querySelector(".js-product-fit-nomatch");
      let productFitmentMatch = productFitElm.querySelector(".js-product-fit-match");
      let productFitmentSpecific = productFitElm.querySelector(".js-product-fit-specific");
      let btnRedirect = productFitElm.querySelector(".js-btn-redirect");
      if (lastSearch) {
        if (this.hasFitment) {
          btnRedirect.href = theme.routes.allProductsCollectionUrl;
          btnRedirect.innerHTML = lastSearch.split("__").join(" ");
          productFitmentMatch.removeClass("d-none");
          productFitmentNomatch.addClass("d-none");
          productFitmentSpecific.addClass("d-none");
          productFitElm.removeClass("d-none");
        } else {
          productFitmentNomatch.removeClass("d-none");
          productFitmentMatch.addClass("d-none");
          productFitmentSpecific.addClass("d-none");
          productFitElm.removeClass("d-none");
        }
      } else {
        productFitmentSpecific.removeClass("d-none");
        productFitmentNomatch.addClass("d-none");
        productFitmentMatch.addClass("d-none");
        productFitElm.removeClass("d-none");
      }
      document.addEventListener("changeVehicle", async ({ detail }) => {
        if (!!detail) {
          this.hasFitment = await this.isFitment();
          if (this.hasFitment) {
            btnRedirect.href = theme.routes.allProductsCollectionUrl;
            btnRedirect.innerHTML = detail.split("__").join(" ");
            productFitmentMatch.removeClass("d-none");
            productFitmentSpecific.addClass("d-none");
            productFitmentNomatch.addClass("d-none");
            productFitElm.removeClass("d-none");
          } else {
            productFitmentNomatch.removeClass("d-none");
            productFitmentSpecific.addClass("d-none");
            productFitmentMatch.addClass("d-none");
            productFitElm.removeClass("d-none");
          }
        } else {
          productFitmentSpecific.removeClass("d-none");
          productFitmentNomatch.addClass("d-none");
          productFitmentMatch.addClass("d-none");
          productFitElm.removeClass("d-none");
        }
      });
    },
    renderFitmentList: async function() {
      let { container } = this;
      let fitmentListContainer = container.querySelector("#fitment-list");
      let template = fitmentListContainer.querySelector("template").content.firstElementChild;
      let fitmentWrapper = template.cloneNode(true);
      let listMake = fitmentWrapper.querySelector(".fitment-list");
      let nameMake = fitmentWrapper.querySelector("h3");
      if (!arn_default.getCookie("arn-filter")) {
        return Promise.resolve(true);
      }
      this.hasFitment = await this.isFitment();
      const lastFilter = arn_default.getCookie("arn-filter");
      const dataFilter = lastFilter.split("__");
      const year = dataFilter[0];
      const make = dataFilter[1];
      const model = dataFilter[2];
      nameMake.innerHTML = make;
      this.fitmentItemList.forEach((item) => {
        const { year: year2, make: make2, model: model2 } = item;
        let li = document.createElement("li");
        let aTag = document.createElement("a");
        aTag.innerHTML = [year2, make2, model2].filter(Boolean).join(" ");
        aTag.setAttribute("data-filter-value", [year2, make2, model2].filter(Boolean).join("__"));
        aTag.href = theme.routes.allProductsCollectionUrl;
        li.append(aTag);
        listMake.append(li);
      });
      fitmentWrapper.append(listMake);
      document.getElementById("product_tab_fitment").removeClass("d-none");
      fitmentListContainer.append(fitmentWrapper);
      [...fitmentListContainer.querySelectorAll("ul.fitment-list")].forEach((fitmentList) => {
        fitmentList.querySelectorAll("a").forEach((element) => {
          element.addEvent("click", (e) => {
            e.preventDefault();
            let filterValue = e.target.dataset.filterValue;
            arn_default.setCookie("arn-filter", filterValue);
            window.location.href = e.target.href;
          });
        });
      });
      return Promise.resolve(true);
    },
    initBtnInstructions: function() {
      let { btnInstructions, modalInstructions } = this.elms;
      let contentLoaeded = false;
      let iframe = modalInstructions.querySelector("iframe");
      let contentURL = iframe.dataset.src;
      btnInstructions.addEvent("click", () => {
        if (!contentLoaeded) {
          iframe.src = contentURL;
        }
        modalInstructions.addClass("is-open");
      });
    },
    updateInventory(variant) {
      if (!variant)
        return;
      let { inventoryContainer, modalAvailability, skuContainer } = this.elms;
      let inventory = this.variantsInventory[variant.id];
      let inventoryStatus, messageStatus = "";
      let hasSpecialOrder = inventoryContainer.dataset.specialOrder;
      let hasPreorder = inventoryContainer.dataset.preorder;
      let regular_oversellable = inventoryContainer.dataset.regularOversellable;
      inventoryContainer.querySelectorAll("[data-variant-id]").forEach((item) => {
        item.classList.toggle("active", item.dataset.variantId.split(",").includes(variant.id.toString()));
      });
      if (inventoryContainer) {
        modalAvailability.querySelector(".js-variant-title").innerHTML = inventory.variantTitleModal;
        modalAvailability.querySelector(".js-vancouver").innerHTML = inventory.vancouver;
        modalAvailability.querySelector(".js-cloverdale").innerHTML = inventory.cloverdale;
        modalAvailability.querySelector(".js-thvancouver").innerHTML = inventory.thvancouver;
        modalAvailability.querySelector(".js-calgary").innerHTML = inventory.calgary;
        modalAvailability.querySelector(".js-montreal").innerHTML = inventory.montreal;
        modalAvailability.querySelector(".js-card-vancouver").innerHTML = inventory.cardVancouver;
        modalAvailability.querySelector(".js-shipping-method").innerHTML = inventory.shippingMethod;
        if (inventory.sku_metafield != "null") {
          skuContainer.style.opacity = 1;
          skuContainer.querySelector(".js-sku").innerHTML = inventory.sku_metafield;
        } else {
          skuContainer.style.opacity = 0;
          skuContainer.querySelector(".js-sku").innerHTML = "";
        }
        if (inventory.isSubcomponents) {
          !!modalAvailability.querySelector(".js-subcomponent") && modalAvailability.querySelector(".js-subcomponent").removeClass("d-none");
          !!modalAvailability.querySelector(".js-none-subcomponent") && modalAvailability.querySelector(".js-none-subcomponent").addClass("d-none");
        } else {
          !!modalAvailability.querySelector(".js-none-subcomponent") && modalAvailability.querySelector(".js-none-subcomponent").removeClass("d-none");
          !!modalAvailability.querySelector(".js-subcomponent") && modalAvailability.querySelector(".js-subcomponent").addClass("d-none");
        }
      }
    },
    showModalAvailability() {
      let { modalAvailability } = this.elms;
      let overlay = modalAvailability.querySelector(".js-overlay");
      let close = modalAvailability.querySelector(".js-close-modal");
      modalAvailability.addClass("is-open");
      overlay.addEvent("click", function() {
        modalAvailability.removeClass("is-open");
      });
      close.addEvent("click", function() {
        modalAvailability.removeClass("is-open");
      });
    },
    toggle() {
      let btns = document.querySelectorAll(".js-btn-toggle");
      btns.length > 0 && btns.forEach((btn) => {
        btn.addEventListener("click", function() {
          this.classList.toggle("active");
          let panel = this.nextElementSibling;
          panel.style.maxHeight ? panel.style.maxHeight = null : panel.style.maxHeight = panel.scrollHeight + "px";
        });
      });
    },
    isFitment: async function() {
      if (!arn_default.getCookie("arn-filter")) {
        return false;
      }
      const { _source: { ymms } } = await getFitmentTableData(theme.product.id);
      const lastFilter = arn_default.getCookie("arn-filter");
      const dataFilter = lastFilter.split("__");
      const year = dataFilter[0];
      const make = dataFilter[1];
      const model = dataFilter[2];
      const hasFitmentList = ymms.some((i) => {
        return i.year == year && i.make == make && i.model == model;
      });
      this.fitmentItemList = ymms;
      return hasFitmentList;
    }
  };

  // app/scripts/common/section/product-related.js
  var ProductRelated = {
    onLoad: function() {
      let { container } = this;
      this.elms = {
        slideContainer: container.querySelector(".slider-container")
      };
      this.balanceHeight();
      const resizeObserver = new ResizeObserver((entries) => {
        this.balanceHeight();
      });
      resizeObserver.observe(container);
      this.initSlide();
    },
    initSlide: function() {
      let { slideContainer } = this.elms;
      let config = JSON.parse(slideContainer.querySelector("[data-tns-config]").innerHTML);
      config.onInit = () => {
        slideContainer.addClass("slider-initialized");
      };
      this.slide = tns(config);
    },
    balanceHeight: function() {
      let { container } = this;
      let maxHeight = 0;
      container.querySelectorAll(".product-card_wrapper").forEach((item) => {
        item.style.height = null;
        let clientHeight = item.clientHeight;
        if (clientHeight > maxHeight) {
          maxHeight = clientHeight;
        }
      });
      container.style.setProperty("--balance-height", maxHeight + "px");
    }
  };

  // app/scripts/common/function/cookie.js
  var Cookie = {
    get: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? keyValue[2] : null;
    },
    set: function(key, value, expiry) {
      var expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
    },
    delete: function(key) {
      var keyValue = this.get(key);
      this.set(key, keyValue, "-1");
    }
  };

  // app/scripts/common/section/recently-view.js
  var ProductRecentlyView = {
    onLoad: function() {
      let { container } = this;
      let productHandle = theme.product.handle;
      let arrRecentView = Cookie.get("recently-view") ? JSON.parse(Cookie.get("recently-view")) : [];
      let arrFiltered = arrRecentView.filter((item) => item != productHandle);
      let productsNotFound = [];
      if (arrFiltered.length !== 0) {
        let slideElm = container.querySelector(".js-tns");
        let url = slideElm.getAttribute("data-url");
        Promise.all(
          arrFiltered.map((item) => {
            return fetch(url + item).then((res) => res.text());
          })
        ).then((res) => {
          res = res.filter((item, index) => {
            if (item.includes("Product Not Found")) {
              productsNotFound.push(index);
              return false;
            }
            return true;
          });
          let content = res.join("");
          if (content.trim()) {
            slideElm.innerHTML = content;
            document.dispatchEvent(new CustomEvent("initProduct", { detail: slideElm }));
            this.initSlider();
            container.removeClass("is-hide");
          }
          arrRecentView = arrRecentView.filter((handle, index) => !productsNotFound.includes(index));
          if (!arrRecentView.includes(productHandle)) {
            arrRecentView.unshift(productHandle);
            arrRecentView.length > 10 && (arrRecentView.length = 10);
          }
          Cookie.set("recently-view", JSON.stringify(arrRecentView), 2);
        });
      } else {
        if (!arrRecentView.includes(productHandle)) {
          arrRecentView.unshift(productHandle);
          arrRecentView.length > 10 && (arrRecentView.length = 10);
          Cookie.set("recently-view", JSON.stringify(arrRecentView), 2);
        }
      }
    },
    initSlider: function() {
      let { container } = this;
      let config = JSON.parse(container.querySelector("[data-tns-config").innerHTML);
      this.balanceHeight();
      setTimeout(() => {
        this.balanceHeight();
      }, 2e3);
      const resizeObserver = new ResizeObserver((entries) => {
        this.balanceHeight();
      });
      resizeObserver.observe(container);
      this.slide = tns(config);
    },
    balanceHeight: function() {
      let { container } = this;
      let maxHeight = 0;
      container.querySelectorAll(".product-card_wrapper").forEach((item) => {
        item.style.height = null;
        let clientHeight = item.clientHeight;
        if (clientHeight > maxHeight) {
          maxHeight = clientHeight;
        }
      });
      container.style.setProperty("--balance-height", maxHeight + "px");
    }
  };

  // app/scripts/common/section/product-featured-collections.js
  var ProductFeaturedCollections = {
    onLoad: function() {
      let { container } = this;
      this.elms = {
        slideContainer: container.querySelector(".slider-container")
      };
      this.initSlide();
    },
    initSlide: function() {
      let { slideContainer } = this.elms;
      let config = JSON.parse(slideContainer.querySelector("[data-tns-config]").innerHTML);
      config.onInit = () => {
        slideContainer.addClass("slider-initialized");
      };
      this.slide = tns(config);
    }
  };

  // app/scripts/common/function/variant-component.js
  var variantComponent = class extends HTMLElement {
    constructor() {
      super();
      this.variantArr = Array.from(this.querySelectorAll(".js-variant-component")).map((i) => i.value);
      const arrayPromise = [];
      this.variantArr.forEach((id) => {
        arrayPromise.push(this.fetch(id));
      });
      Promise.all(arrayPromise).then((e) => {
        this.variantArr = e;
        this.variantArr.length > 0 && this.variantArr.every((i) => i.available) && this.updateState();
      });
    }
    fetch(id) {
      return new Promise((resolve, reject) => {
        fetch(this.dataset.base + id + this.dataset.section).then((e) => e.text()).then((e) => {
          const div = document.createElement("div");
          div.innerHTML = e;
          resolve(JSON.parse(div.querySelector(".shopify-section")?.innerHTML || "{}"));
        });
      });
    }
    updateState() {
      const button = document.getElementById("AddToCart");
      button.removeAttribute("disabled");
      button.addEventListener("click", this.submitted.bind(this));
    }
    submitted(e) {
      e.preventDefault();
      const items = [];
      const btnSubmit = e.target.closest("button");
      this.variantArr.forEach((i) => {
        items.push({
          id: i.id,
          quantity: 1
        });
      });
      btnSubmit.addClass("pending");
      fetch(this.dataset.cartAddUrl + ".js", {
        method: "POST",
        body: JSON.stringify({ items }),
        headers: { "Content-Type": "application/json" }
      }).finally(() => {
        btnSubmit.removeClass("pending");
      });
    }
  };
  customElements.get("variant-component") || customElements.define("variant-component", variantComponent);

  // app/scripts/product-page.js
  (function() {
    register("product-default", ProductDefault);
    register("social-proof", SlideShow);
    register("product-related", ProductRelated);
    register("product-recent-view", ProductRecentlyView);
    register("product-featured-collections", ProductFeaturedCollections);
    class klaviyoAPI extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onFormSubmit.bind(this));
      }
      onFormSubmit(event) {
        event.preventDefault();
        const url = `https://a.klaviyo.com/onsite/components/back-in-stock/subscribe`;
        fetch(url, {
          method: "post",
          body: new FormData(this.form)
        }).then((response) => response.json()).then((data) => {
          console.log("Email:", data.email);
          console.log("Success:", data.success);
          document.querySelector(".js-klaviyo-modal").classList.add("is-open");
          document.querySelector(".js-submit").classList.add("d-none");
          document.querySelector(".js-klaviyo-modal .newsletter_subscription").classList.remove("d-none");
        }).catch((error) => {
          console.error("Error:", error);
        });
      }
    }
    customElements.define("klaviyo-api", klaviyoAPI);
    load("*");
    moveElement();
    window.addEventListener("resize", () => {
      moveElement();
    });
    function moveElement() {
      let width = screen.width;
      let emlAppendMobile = document.querySelector(".js-append-warpper-mobile"), emlAppendDesktop = document.querySelector(".js-append-warpper-desktop"), wrapperMove = document.querySelector("#wrapper-move-mobile");
      width < 992 ? emlAppendMobile.appendChild(wrapperMove) : emlAppendDesktop.appendChild(wrapperMove);
    }
    console.log("product.js loaded");
  })();
})();
